import React from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";

const Layout = ({ children }) => {
  const location = useLocation();

  // routes that should render full-bleed (no app wrapper / no centered max-width)
  const fullBleedRoutes = ["/login", "/"]; // add other public/unwrapped routes here


  if (fullBleedRoutes.includes(location.pathname)) {
    // Render children directly for login-like pages so their background can cover full viewport
    return <>{children}</>;
  }

  const showNavbar = ["/dashboard", "/admin-dashboard", "/superuser-dashboard"].includes(location.pathname);

  return (
    <div className="body-bg min-h-screen font-inter flex flex-col">
      {showNavbar && <Navbar />}
      {/* main constrained content area for app pages */}
      <main className="p-6 max-w-7xl mx-auto flex-1">
        {children}
      </main>

      <footer className="text-center text-sm text-app-muted py-6 bg-transparent border-t-0 shadow-none">
        © {new Date().getFullYear()} Tasket — Greenated — made with love⚡
      </footer>
    </div>
  );
};

export default Layout;
